<template>
  <dtunes-modal :dialog="dialog" @openModal = "dialog = true" @closeModal = "dialog = false">
    <template v-slot:button> Create new store </template>
    <template v-slot:content>
      <v-card flat class="dt-border pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">CREATE NEW STORE</p>
        </v-card-title>
        <v-card-text>
          <v-text-field
            style="border-color: red"
            color="auto"
            label="Name"
            outlined
            v-model="cardName"
          ></v-text-field>
          <v-file-input
            :rules="rules"
            accept="image/*"
            placeholder="Upload Logo"
            prepend-icon="mdi-camera"
            outlined
            id="logo"
            ref="storeImage"
            label="Upload Logo"
          ></v-file-input>
          <v-file-input
            :rules="rules"
            accept="image/*"
            placeholder="Upload Icon"
            prepend-icon="mdi-camera"
            outlined
            id="icon"
            ref="storeImage"
            label="Upload Icon"
          ></v-file-input>
          <br />
          <default-button :loading="loading" :disabled="!isComplete" @click="createStore">Create Store</default-button>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// ================ IMPORT COMPONENTS ================
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";

//  =============== IMPORT SERVICES ==============
import * as storageService from "@/utils/firebase/storage";
import { StoresService } from "@/services";

export default {
  data: () => ({
    cardName: "",
    tmStamp: '',
    dialog:false,
    icon:'',
    logo:'',
    fileName: [],
    loading:false,
    rules: [
      (value) =>
        !value ||
        value.size < 2000000 ||
        "Avatar size should be less than 2 MB!",
    ],
    imageURL:''
  }),
  components: {
    DtunesModal,
    DefaultButton,
  },
  computed:{
      isComplete() {
        return this.cardName;
    },
    },
  methods: {
    async uploadImage(location) {
      let date = Date.now()
      let path = `/giftcard/stores/${location}`;
      let pixName = this.cardName + '-'+ date.toString();
      let file = document.getElementById(location).files[0];
      let image = await storageService.uploadImages(path, pixName, file);
      this[location] = image;
    },

    async uploadArtifacts() {
      await Promise.all([
        this.uploadImage('logo'),
        this.uploadImage('icon')
      ])
    },
    
    async createStore(){
      try {
        this.loading = true
        await this.uploadArtifacts();
        const data = await StoresService.createStores({
            name: this.cardName,
            icon:this.icon,
            logo : this.logo
        });
        this.loading = false;
        this.$store.dispatch('toast', {
          message: ` ${this.cardName} store created sucessfully`,
          variant: 'success'
        });
        console.log(data);
        this.dialog = false;
        this.$emit('reload');
      } catch (error) {
        this.loading = false
        console.log(error);
      }
      
    }
  },
};
</script>